import React, { useState, useEffect } from 'react';
import { FaSpinner, FaTimes } from 'react-icons/fa';
import { toast } from 'react-hot-toast';


// ✅ Clear
const EmailPurchaseOrderModalMobile = ({ openPopup, details, items, handleClose }) => {

    const [sendingEmail, setSendingEmail] = useState(false);

    const [emailDetails, setEmailDetails] = useState({
        id: details?.id,
        supplierId: details?.supplier?.id,
        supplierName: details?.supplier?.name,
        representative: '',
        receiver: '',
        subject: '',
        message: '',
        type: openPopup,
    });

    useEffect(() => {
    
        api.getEmailTemplate(`send_purchase_order`).then((res) => {
            if (res?.status) {
                let subject = res?.data?.subject?.replace(/{purchase_order_reference_no}/g, details?.purchase_order_id);

                let message = res?.data?.template?.replace(/{purchase_order_reference_no}/g, details?.purchase_order_id);
                if (details?.supplier?.contact) {
                    message = message?.replace(/{supplier_representative}/g, details?.supplier?.contact);
                }
                setEmailDetails({ ...emailDetails, subject: subject, message: message, receiver: details?.supplier?.email });
            }
        });
    }, []);

    const sendEmail = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailDetails?.supplierName?.trim() === '') {
            toast.error(`Please select supplier`);
            return false;
        } else if (!emailRegex.test(emailDetails?.receiver)) {
            toast.error(`Please enter valid email address`);
            return false;
        } else if (emailDetails?.subject.trim() === '') {
            toast.error(`Please enter email subject`);
            return false;
        } else {
            setSendingEmail(true);
            api.sendPurchaseOrderEmailToSupplier(emailDetails).then((res) => {
                if (res?.status) {
                    setSendingEmail(false);
                    toast.success(res?.message);
                    handleClose();
                } else {
                    setSendingEmail(false);
                    toast.error(res?.message);
                }
            });
        }
    };

    if (!openPopup) return null;

    return (
        <div
            className="d-flex"
            style={{
                width: '100vw',
                height: '100dvh',
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 20,
                background: 'rgba(0,0,0,0.07)',
                justifyContent: 'center',
                alignItems: 'end',
                paddingBottom: '90px',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)'
            }}
        >
            <div
                className="popup product-popup-mobile d-md-none"
                style={{
                    position: 'relative',
                    transform: 'none',
                    top: 0,
                    left: 0,
                    maxWidth: '90%',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
                    width: '100%',
                    padding: '24px 16px 0 16px',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                    <h5 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>
                        Send Purchase Order {details?.purchase_order_id} to {details?.supplier?.name ?? 'the supplier'}
                    </h5>
                </div>


                <div className="form-group" style={{ marginBottom: 12 }}>
                    <label className="font500">Send to</label>
                    <input
                        type="text"
                        className="form-control"
                        value={emailDetails?.receiver}
                        onChange={(e) => setEmailDetails({ ...emailDetails, receiver: e.target.value })}
                        placeholder="Enter recipient's email address"
                        style={{ marginTop: 4 }}
                    />
                </div>
                <div className="form-group" style={{ marginBottom: 12 }}>
                    <label className="font500">Subject</label>
                    <input
                        type="text"
                        className="form-control"
                        value={emailDetails?.subject}
                        onChange={(e) => setEmailDetails({ ...emailDetails, subject: e.target.value })}
                        placeholder="Enter email subject"
                        style={{ marginTop: 4 }}
                    />
                </div>
                <div className="form-group" style={{ marginBottom: 12 }}>
                    <label className="font500">Email message</label>
                    <textarea
                        className="form-control"
                        rows={8}
                        value={emailDetails?.message}
                        onChange={(e) => setEmailDetails({ ...emailDetails, message: e.target.value })}
                        style={{ resize: 'none', marginTop: 4 }}
                    />
                </div>

                <div
                    className="btnarea"
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        background: '#fff',
                        padding: '16px 0 12px 0',
                        zIndex: 30,
                        display: 'flex',
                        gap: 10,
                        justifyContent: 'center',
                        marginTop: 'auto'
                    }}
                >
                    <button
                        className="btn btn-main"
                        onClick={sendEmail}
                        disabled={!emailDetails?.message.trim() || sendingEmail}
                    >
                        {sendingEmail ? (
                            <>
                                <FaSpinner className="spinner" /> Sending
                            </>
                        ) : (
                            'Send'
                        )}
                    </button>
                    <button className="btn new-btn-error" onClick={handleClose}>
                        <FaTimes /> Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EmailPurchaseOrderModalMobile;
